module.exports = __webpack_public_path__ + "static/media/ttc_winter.28943f95.jpg";